<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    class="mb40"
    :pagination="pagination"
  >
    <template v-slot:bodyCell="{ column, record, index }">
      <template v-if="column.dataIndex == 'id'">
        {{ index + 1 + (pagination.current - 1) * pagination.pageSize }}
      </template>
      <template v-if="column.dataIndex == 'imageUrl'">
        <a-image :width="100" :src="record.imageUrl"></a-image>
      </template>
      <template v-if="column.dataIndex == 'operate'">
        <a-popconfirm
          title="确定设置成讲解中吗?"
          @confirm="
            setProduct(
              record,
              index + 1 + (pagination.current - 1) * pagination.pageSize
            )
          "
        >
          <a-button type="link" v-if="record.status === 0">
            讲解中
          </a-button>
        </a-popconfirm>

        <a-popconfirm title="确定取消讲解吗?" @confirm="cancel()">
          <a-button type="link" v-if="record.status === 1">
            取消讲解
          </a-button>
        </a-popconfirm>
      </template>
    </template>
  </a-table>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped></style>
